import React from "react";
import Header from "./Header";
import HeroSection from "./HeroSection";
import ProductHighlights from "./ProductHighlights";
import HowToParticipate from "./HowToParticipate";
import Timer from "./Timer";
import Transparency from "./Transparency";
import CallToAction from "./CallToAction";
import Footer from "./Footer";
import MegaLotoInfo from "./MegaLotoInfo"; // Importar nueva sección

import "./Landing.css";

const Landing = () => {
  const targetDate = new Date("2024-12-08T18:59:59");

  return (
    <div className="app">
      <Header />
      <HeroSection />
      <ProductHighlights />
      <HowToParticipate />
      <Timer targetDate={targetDate} />
      <MegaLotoInfo /> {/* Nueva sección */}
      <Transparency />
      <CallToAction />
      <Footer />
    </div>
  );
};

export default Landing;
